import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DownloadService {
  downloadAndSaveFile(fileInfo: { url: string; name: string }): Observable<void> {
    return new Observable<void>((observer) => {
      try {
        const fileLink = document.createElement("a");
        fileLink.href = fileInfo.url;
        fileLink.setAttribute("download", fileInfo.name);
        fileLink.target = "_blank";
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);

        observer.next();
        observer.complete();
      } catch (error) {
        observer.error(error);
      }
    });
  }
}
